module.exports = __webpack_public_path__ + "static/media/arrowRightIcon.08a9ad13.svg";